<template>
  <section v-if="displayReviewSection(order)">
    <div v-if="!includeCssClass">
      <hr>
    </div>
    <div :class="{'card panel-white': includeCssClass}">
      <div :class="{'card-body': includeCssClass}">
        <!-- Review Section -->
        <!-- <label>
          {{ $t('message.my_reservations.how_was_cleaner_service01') }}
          {{ order.professional.full_name | firstName }}{{ $t('message.my_reservations.how_was_cleaner_service02')
          }}</label> -->
        <div class="bg-gray px-3 py-2 rounded-all" v-if="order.review_days > 0 && !order.is_reviewed">
          <div v-html="$options.filters.reviewDurationText(order)"></div>
        </div>
        <div class="mt-3 row no-gutters">
          <div class="col-6 pr-2 my-auto">
            <button class="btn btn-success btn-block" v-if="order.review_days > 0 && !order.is_reviewed" 
                    @click="openReviewModal(-1, order.id, order.professional)">
              {{ $t('message.my_reservations.give_a_review') }}
            </button>
            <span class="-status-accepted" v-if="order.is_reviewed">
              <i class="fas fa-check-circle"></i>&nbsp;{{ $t('message.my_reservations.reviewed') }}
            </span>
          </div>
          <div class="col-6 pl-2">
            <router-link class="btn btn-block btn-outline-info" 
                         :to="`/reservation/${order.id}/professional-tip`"
                         v-if="!order.professional_tip">
              {{ $t('message.professional_tip.title') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- Review Modal -->
    <review-modal ref="reviewModal"/>
  </section>
</template>

<script>
  import ReviewModal from './ReviewModal'
  import TipSection from './ProfessionalTipSection'

  export default {
    props: {
      order: Object,
      includeCssClass: {
        type: Boolean,
        default: true
      }
    },
    components: {
      ReviewModal,
      TipSection
    },
    methods: {
      displayReviewSection (order) {
        return (order.status === 2 && order.cancel === 0 && (order.is_received_order || order.order_report_issue))
      },
      openReviewModal (index, orderId, professional) {
        this.$refs.reviewModal.setOrderData(index, orderId, professional.id, professional.full_picture, professional.full_name)
        this.$refs.reviewModal.showReviewModal(true)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/order/components/ReviewSection.vue